import styled from 'styled-components';

const StyledLogo = styled.img<any>`
  width: 66px;
  margin: 0;
`;

export default StyledLogo;
